<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc" title="Contents">Contents</h2>
<p class="firstverse"><a href="#/Text/Foreword">Foreword</a></p>
<p class="firstverse"><a href="#/Text/Preface">Preface</a></p>
<p class="firstverse"><a href="#/Text/Veritas">Veritas</a></p>
<p class="firstverse"><a href="#/Text/Introduction">Introduction</a></p>
<p class="firstverse"><a href="#/Text/ch1">1: Is There Life After Truth?</a></p>
<p class="firstverse"><a href="#/Text/ch2">2: Time for Truth</a></p>
<p class="firstverse"><span href="#/Text/ch3" title="Link target outside of Sample">3: Reason for God: The Exclusivity of Truth</span></p>
<p class="firstverse"><span href="#/Text/ch4" title="Link target outside of Sample">4: The Language of God: A Scientist Presents Evidence for Belief</span></p>
<p class="firstverse"><span href="#/Text/ch5" title="Link target outside of Sample">5: The New Atheists and the Meaning of Life</span></p>
<p class="firstverse"><span href="#/Text/ch6" title="Link target outside of Sample">6: A Scientist Who Looked and Was Found</span></p>
<p class="firstverse"><span href="#/Text/ch7" title="Link target outside of Sample">7: The Psychology of Atheism</span></p>
<p class="firstverse"><span href="#/Text/ch8" title="Link target outside of Sample">8: Nietzsche Versus Jesus Christ</span></p>
<p class="firstverse"><span href="#/Text/ch9" title="Link target outside of Sample">9: Moral Mammals: Does Atheism or Theism Provide the Best Foundation for Human Worth and Morality?</span></p>
<p class="firstverse"><span href="#/Text/ch10" title="Link target outside of Sample">10: Living Machines: Can Robots Become Human?</span></p>
<p class="firstverse"><span href="#/Text/ch11" title="Link target outside of Sample">11: The Sense of an Ending</span></p>
<p class="firstverse"><span href="#/Text/ch12" title="Link target outside of Sample">12: Simply Christian</span></p>
<p class="firstverse"><span href="#/Text/ch13" title="Link target outside of Sample">13: Why Human Rights Are Impossible Without Religion</span></p>
<p class="firstverse"><span href="#/Text/ch14" title="Link target outside of Sample">14: Radical Marxist, Radical Womanist, Radical Love: What Mother Teresa Taught Me About Social Justice</span></p>
<p class="firstverse"><span href="#/Text/ch15" title="Link target outside of Sample">15: The Whole Gospel for the Whole Person</span></p>
<p class="firstverse"><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstverse"><span href="#/Text/Contributors" title="Link target outside of Sample">Contributors</span></p>
<p class="firstverse"><span href="#/Text/PhotoCredits" title="Link target outside of Sample">Photo Credits</span></p>
<p class="firstverse"><span href="#/Text/VeritasBooks" title="Link target outside of Sample">Veritas Books</span></p>
<p class="firstverse"><span href="#/Text/Series" title="Link target outside of Sample">Other Books in This Series</span></p>
<p class="firstverse"><span href="#/Text/AbouttheEditor" title="Link target outside of Sample">About the Editor</span></p>
<p class="firstverse"><span href="#/Text/MoreTitlesfromIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?aefb5716